import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';

export default function Footer() {
  useEffect(() => {
    const ttChatLoaderS = document.createElement('script');
    document.tomticketChatLoaderScriptVersion = 2;
    ttChatLoaderS.src =
      'https://athix.tomticket.com/scripts-chat/chat.min.js' +
      '?id=EP67940' +
      '&account=4348160P05062025074357' +
      '&autoOpen=0' +
      '&hideWhenOffline=0' +
      '&d=athix' +
      '&ts=' + new Date().getTime() +
      '&ref=' + encodeURIComponent(document.URL);
    ttChatLoaderS.async = true;
    document.body.appendChild(ttChatLoaderS);

    // Cleanup function in case component unmounts
    return () => {
      document.body.removeChild(ttChatLoaderS);
    };
  }, []);

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        textAlign: 'center',
        backgroundColor: 'transparent',
        backdropFilter: 'blur(6px)',
        borderTop: '1px solid #eee',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        © {new Date().getFullYear()} - Locadora de Veículos | v1.0.0
      </Typography>
    </Box>
  );
}
